import React from "react";

import { CartSummary } from "./productStoreCart";

interface Props {
  summary: CartSummary;
}

/** What's paid today, and what's added to the subscription. */
export const ProductStoreCartSummary = ({ summary }: Props) => {
  const { today, subscription } = summary;
  const grouped = today.length > 0 && subscription.length > 0;

  return (
    <div className="ProductStoreCartDialog__summary">
      {today.length > 0 && (
        <div className="ProductStoreCartDialog__summaryGroup">
          {grouped && (
            <p className="ProductStoreCartDialog__summaryLabel">Paid today</p>
          )}
          <dl>
            {today.map((line) => (
              <div key={line.id}>
                <dt>
                  {line.title} × {line.quantity}
                </dt>
                <dd>{line.total}</dd>
              </div>
            ))}
            <div className="ProductStoreCartDialog__subtotal">
              <dt>Subtotal</dt>
              <dd>{summary.subtotal}</dd>
            </div>
          </dl>
        </div>
      )}
      {subscription.length > 0 && (
        <div className="ProductStoreCartDialog__summaryGroup">
          <p className="ProductStoreCartDialog__summaryLabel">
            Added to your subscription
          </p>
          <dl>
            {subscription.map((line) => (
              <div key={line.id}>
                <dt>{line.title}</dt>
                <dd>{line.price}</dd>
              </div>
            ))}
          </dl>
          <p>Today you only pay for the days left in your current term.</p>
        </div>
      )}
      <p>Tax is calculated at checkout.</p>
    </div>
  );
};
